module.exports = __webpack_public_path__ + "static/img/mCyBanner@2x.189bd5e4.png";